import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'

class Base extends PureComponent {
  static propTypes = {
    info: PropTypes.string.isRequired
  }

  render() {
    const {info} = this.props
    return (<p>{info}</p>)
  }
}

export default Base



// WEBPACK FOOTER //
// ./components/Service_Steps/Info/Base/index.jsx